import { createWrapRootElement } from "@ace-hotel/components/create-wrap-root-element";
import WrapPageElement from "@ace-hotel/components/wrap-page-element";
import SearchStore from "./src/models/search-model";

import "@ace-hotel/styles/index.scss";

export const wrapRootElement = createWrapRootElement(SearchStore);
export const wrapPageElement = WrapPageElement;
